import { Col, Container, Row } from "reactstrap";
import { CardsView, JobSearch } from "../../../../constants";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import LeftSidebar from "../common/leftSidebar";
import RightSidebarCards from "../common/rightSidebarCards";

const CardsViewContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={CardsView} parent={JobSearch} />
      <Container fluid>
        <Row>
          <LeftSidebar />
          <Col xl="9" className="xl-60 box-col-12">
            <Row>
              <RightSidebarCards startLimit={0} colClass="col-xl-6 xl-100" />
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CardsViewContainer;
